import store from '../store/index.js';

const isActivePenalty = async (to, from, next) => {
  let currentUser = store.getters['currentUserModule/getCurrentUser'];

  if (currentUser === null) {
    try {
      currentUser = await store.dispatch('currentUserModule/loadCurrentUser');
    } catch (error) {
      next({ name: 'prime' });
      return;
    }
  }

  next(currentUser.isActivePenalty ? undefined : { name: 'prime' });
};

const penalties = [
  {
    path: '/penalties',
    name: 'penalties',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Штрафи'
    },
    beforeEnter: isActivePenalty,
    component: () => import('../pages/penalties-page/index.vue')
  },
  {
    path: '/penalties/:id',
    name: 'show-penalty',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про штраф'
    },
    beforeEnter: isActivePenalty,
    component: () => import('../pages/penalties-page/show.vue')
  },
  {
    path: '/penalty/:docId',
    name: 'show-penalty-for-client',
    meta: {
      layout: 'loginLayout',
      title: 'Штрафи'
    },
    component: () => import('../components/app/penalties/PenaltyPage.vue')
  },
  {
    path: '/penalty/:docId/:billId',
    name: 'check-penalty-for-client',
    meta: {
      layout: 'loginLayout',
      title: 'Штрафи'
    },
    component: () => import('../components/app/penalties/PenaltyPage.vue')
  },
];

export default penalties;
